import { useMutationDeleteReportTemplate } from 'api/mutations/deleteReportTemplate.mutation';
import { useQueryGetReportTemplateList } from 'api/queries/getReportTemplateList.query';
import { useQueryGetReportsTags } from 'api/queries/getReportsTags.query';

export type UseReportTemplates = ReturnType<typeof useReportTemplates>;

export const useReportTemplates = () => {
    const deleteReportTemplate = useMutationDeleteReportTemplate();

    return {
        api: {
            getReportTemplates: useQueryGetReportTemplateList(getPayloadForGetReportTemplate),
            deleteReportTemplate: {
                instance: deleteReportTemplate,
            },
            getTagList: useQueryGetReportsTags(),
        },
    };
};

// AS LONG AS THE FILTER IS NOT CHANGING THE PAYLOAD SHOULD BE HARD CODED
const getPayloadForGetReportTemplate = {
    filter: {
        filters: [],
    },
};
